module.exports = "::ng-deep .address-modal>div.modal-dialog {\r\n    width: 500px;\r\n    max-width: 1366px !important;\r\n    margin: 100px auto;\r\n}\r\n::ng-deep .address-modal>div.modal-dialog .error-msg {\r\n    color: red;\r\n    margin-top: 17%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal-popup/address-popup/address-popup.component.css
// module id = ./src/app/shared/modal-popup/address-popup/address-popup.component.css
// module chunks = main